export const CUSTOMER_VEHICLES_MAPPER = {
  internalId: { label: 'Internal ID', key: 'internalId' },
  vin: { label: 'VIN', key: 'vin' },
  createdAt: { label: 'Created At', key: 'createdAt' },
  updatedAt: { label: 'Updated At', key: 'updatedAt' },
  manufacturer: { label: 'Brand', key: 'manufacturer' },
  model: { label: 'Model', key: 'model' },
  year: { label: 'Year', key: 'year' },
  plate: { label: 'Plate', key: 'plate' },
  type: { label: 'Type', key: 'type' },
};

export const INITIAL_CUSTOMER_VEHICLES_GRID_COLUMNS = [
  ...Object.values(CUSTOMER_VEHICLES_MAPPER).map((field) => ({
    ...field,
    value: true,
  })),
];

export const CUSTOMER_VEHICLES_PAGE_SIZE = 100;

export const CUSTOMER_VEHICLE_USERS_MAPPER = {
  id: { label: 'ID', key: 'id' },
  name: { label: 'Name', key: 'name' },
  role: { label: 'Role', key: 'role' },
  email: { label: 'Email', key: 'email' },
};

export const CUSTOMER_VEHICLE_USER_ROLES = {
  owner: { text: 'OWNER', value: 'OWNER' },
  admin: { text: 'ADMIN', value: 'ADMIN' },
  operator: { text: 'OPERATOR', value: 'OPERATOR' },
};

export const CUSTOMER_VEHICLE_TYPES = [
  { text: 'CAR', value: 'CAR' },
  { text: 'SCOOTER', value: 'SCOOTER' },
  { text: 'ELECTRONIC BIKE', value: 'ELECTRONIC_BIKE' },
];

export const CUSTOMER_VEHICLE_BUNDLES_MAPPER = {
  id: { label: 'ID', key: 'id' },
  name: { label: 'Name', key: 'name' },
  offerings: { label: 'Offerings', key: 'offerings' },
  billingInfo: { label: 'Billing Info', key: 'billingInfo' },
  price: { label: 'Price', key: 'price' },
};

export const CUSTOMER_VEHICLES_SIDEBAR_MAPPER = {
  id: { label: 'ID', key: 'id' },
  internalId: { label: 'Internal ID', key: 'internalId' },
  createdAt: { label: 'Created At', key: 'createdAt' },
  updatedAt: { label: 'Updated At', key: 'updatedAt' },
  status: { label: 'Status', key: 'status' },
  vin: { label: 'VIN', key: 'vin' },
  plate: { label: 'Plate', key: 'plate' },
  manufacturer: { label: 'Brand', key: 'manufacturer' },
  transmission: { label: 'Transmission', key: 'transmission' },
  model: { label: 'Model', key: 'model' },
  year: { label: 'Year', key: 'year' },
  edition: { label: 'Edition', key: 'edition' },
  displacement: { label: 'CC', key: 'displacement' },
  mileage: { label: 'Mileage', key: 'mileage' },
  fuel: { label: 'Fuel', key: 'fuel' },
  gear: { label: 'Gear', key: 'gear' },
  type: { label: 'Type', key: 'type' },
  tires: { label: 'Tires', key: 'tires' },
};

export const CUSTOMER_VEHICLES_TABS = [
  {
    label: 'Users',
    key: 'users',
  },
  {
    label: 'Bundles',
    key: 'bundles',
    disabled: true,
  },
  {
    label: 'Media',
    key: 'media',
  },
];
